import { ClarityType } from '../clarityValue';
function responseErrorCV(value) {
    return { type: ClarityType.ResponseErr, value };
}
function responseOkCV(value) {
    return { type: ClarityType.ResponseOk, value };
}
export { responseErrorCV, responseOkCV };
//# sourceMappingURL=responseCV.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@stacks/connect/node_modules/@stacks/transactions/dist/esm/clarity/types/responseCV.js
// module id = null
// module chunks = 